<template>
    <div id="app" class="resume" ref="content">
        <div class="resume__top">
            <div class="resume__name">
                Giorgi Khatchapuridze
            </div>
            <div class="resume__job">
                Front-end Developer
            </div>
        </div>
        <div class="resume__center">
            <div class="resume__aside">

                <img src="./assets/hire-me.jpg" alt="me">

                <div class="resume__aside-contact">
                    <span>contacts</span>
                    <div class="contact-list">
                        <div class="contact-list__item"><img src="./assets/call.png" alt=""> <span>577 75 80 88</span>
                        </div>
                        <div class="contact-list__item"><img src="./assets/mail.png" alt=""><span><a
                                href="mailto:giorgi.khatchapuridze.1@gmail.com">giorgi.khatchapuridze.1@gmail.com</a></span>
                        </div>
                        <div class="contact-list__item"><img src="./assets/location.png" alt="">
                            <span>Georgia,Tbilisi</span></div>
                        <div class="contact-list__item"><img
                                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQUW1xthVx3S9zjsDliGtUBuj7csQwPIdtx_VJqPCFCKQgRzQ91&s"
                                alt="linkedin"> <span><a target="_blank" href="https://www.linkedin.com/in/giorgi-khachapuridze-6a5361183">Giorgi Khatchapuridze</a> </span></div>
                    </div>
                </div>

                <div class="resume__skills">
                    <div class="resume__skills-title">Technical skills</div>

                    <div class="resume__skills-items">
                        <div class="circle-wrap">
                            <div class="circle">

                                <div class="mask full">
                                    <div class="fill"></div>
                                </div>

                                <div class="mask half">
                                    <div class="fill"></div>
                                </div>

                                <div class="inside-circle">
                                    <img
                                            src="https://www.stickpng.com/assets/images/58482acecef1014c0b5e4a1e.png"
                                            alt="">
                                </div>

                            </div>
                            <span class="skill-title">Vue js</span>
                        </div>
                        <div class="circle-wrap">
                            <div class="circle">

                                <div class="mask-nxt full-nxt">
                                    <div class="fill-nxt"></div>
                                </div>

                                <div class="mask-nxt half-nxt">
                                    <div class="fill-nxt"></div>
                                </div>

                                <div class="inside-circle">
                                    <img
                                            src="https://www.soudegesu.com/images/icons/nuxt_icon.png"
                                            alt="">
                                </div>
                            </div>
                            <span class="skill-title">Nuxt js</span>
                        </div>
                        <div class="circle-wrap">
                            <div class="circle">

                                <div class="mask-js full-js">
                                    <div class="fill-js"></div>
                                </div>

                                <div class="mask-js half-js">
                                    <div class="fill-js"></div>
                                </div>

                                <div class="inside-circle">
                                    <img
                                            src="https://logodix.com/logo/374736.png"
                                            alt="">
                                </div>
                            </div>
                            <span class="skill-title">Javascript</span>
                        </div>
                        <div class="circle-wrap">
                            <div class="circle">

                                <div class="mask-js full-js">
                                    <div class="fill-js"></div>
                                </div>

                                <div class="mask-js half-js">
                                    <div class="fill-js"></div>
                                </div>

                                <div class="inside-circle">
                                    <img
                                            src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/HTML5_logo_and_wordmark.svg/512px-HTML5_logo_and_wordmark.svg.png"
                                            alt="">
                                </div>
                            </div>
                            <span class="skill-title">Html</span>
                        </div>
                        <div class="circle-wrap">
                            <div class="circle">

                                <div class="mask-js full-js">
                                    <div class="fill-js"></div>
                                </div>

                                <div class="mask-js half-js">
                                    <div class="fill-js"></div>
                                </div>

                                <div class="inside-circle">
                                    <img
                                            src="https://upload.wikimedia.org/wikipedia/commons/d/d5/CSS3_logo_and_wordmark.svg"
                                            alt="">
                                </div>
                            </div>
                            <span class="skill-title">Css</span>
                        </div>
                        <div class="circle-wrap">
                            <div class="circle">

                                <div class="mask-js full-js">
                                    <div class="fill-js"></div>
                                </div>

                                <div class="mask-js half-js">
                                    <div class="fill-js"></div>
                                </div>

                                <div class="inside-circle">
                                    <img
                                            src="https://sass-lang.com/assets/img/styleguide/color-1c4aab2b.png"
                                            alt="">
                                </div>
                            </div>
                            <span class="skill-title">Scss</span>
                        </div>
                        <div class="circle-wrap">
                            <div class="circle">

                                <div class="mask-js full-js">
                                    <div class="fill-js"></div>
                                </div>

                                <div class="mask-js half-js">
                                    <div class="fill-js"></div>
                                </div>

                                <div class="inside-circle">
                                    <img
                                            src="https://upload.wikimedia.org/wikipedia/commons/thumb/d/db/Npm-logo.svg/1280px-Npm-logo.svg.png"
                                            alt="npm">
                                </div>
                            </div>
                            <span class="skill-title">Npm</span>
                        </div>
                        <div class="circle-wrap">
                            <div class="circle">

                                <div class="mask-nxt full-nxt">
                                    <div class="fill-nxt"></div>
                                </div>

                                <div class="mask-nxt half-nxt">
                                    <div class="fill-nxt"></div>
                                </div>

                                <div class="inside-circle">
                                    <img
                                            src="https://cdn.pixabay.com/photo/2015/04/23/17/41/node-js-736399_960_720.png"
                                            alt="">
                                </div>
                            </div>
                            <span class="skill-title">Node Js</span>
                        </div>
                    </div>


                </div>

            </div>
            <div class="resume__main">
                <div class="resume__educ">
                    <p class="resume__main-title">Education</p>
                    <ul>
                        <li>Business and Technology University (Information Technology)</li>
                        <li>Tbc It Academy</li>
                    </ul>
                </div>
                <div class="resume__lang">
                    <p class="resume__main-title">Languages</p>
                    <ul>
                        <li>English</li>
                        <li>Russian</li>
                        <li>Georgian(native)</li>
                    </ul>
                </div>
                <div class="resume__pr-skills">
                    <p class="resume__main-title">Professional Skills</p>
                    <ul>
                        <li>Learning new technologies and keeping abreast of markets developments</li>
                        <li>Teamwork</li>
                        <li>Adaptable and able to quickly pick up new techniques</li>
                        <li>Creative thinking</li>
                        <li>Learning new technologies and keeping abreast of markets developments</li>
                        <li>Attention to detail</li>
                    </ul>
                </div>
                <div class="resume__experience">
                    <p class="resume__main-title">Work Experience</p>
                    <ul>
                        <li>
                            01/09/2019 - present Front-end Developer
                            <a href="Vendoo" class="comp">Vendoo</a>
                        </li>
                        <li>Freelancer</li>
                        <li><a href="https://github.com/khachapuridze" target="_blank">My Github</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <footer class="resume__footer">
      <span>
        © {{this.date}} Giorgi Khatchapuridze <br> All Rights Reserved
      </span>
        </footer>

    </div>
</template>

<script>

    export default {
        name: 'app',
        data() {
            return {
                msg: 'Hi ',
                date: null
            }
        },
        mounted() {
            let dt = new Date;
            this.date = dt.getFullYear();

        },
        methods: {}

    }
</script>

<style lang="scss">
    @import "assets/main";

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }
</style>
